import { useCallback, useEffect, useState } from 'react';
import { listDomains } from 'services/DomainService';
import { listSenders } from 'services/SenderService';
import {
    enrichSendersWithDomainVerification,
    getMarketingSendersAndDomainsFromSettled,
} from '../../utils/marketingSenderDomainVerification';

export function useObtainSenders() {
    const [senders, setSenders] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchSenders = useCallback(() => {
        setLoading(true);
        return Promise.allSettled([listSenders(), listDomains()])
            .then(([sendersResult, domainsResult]) => {
                const { rawSenders, domains } = getMarketingSendersAndDomainsFromSettled(
                    sendersResult,
                    domainsResult,
                );
                setSenders(enrichSendersWithDomainVerification(rawSenders, domains));
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        void fetchSenders();
    }, [fetchSenders]);

    return { senders, loading, fetchSenders };
}
